import { createTheme, type PaletteMode } from "@mui/material";

export function buildTheme(mode: PaletteMode) {
  return createTheme({
    palette: {
      mode,
      ...(mode === "light"
        ? {
            primary: { main: "#7c3aed" },
            secondary: { main: "#a855f7" },
            error: { main: "#ef4444" },
            warning: { main: "#f59e0b" },
            success: { main: "#10b981" },
            info: { main: "#3b82f6" },
            background: { default: "#f8fafc", paper: "#ffffff" },
          }
        : {
            primary: { main: "#a78bfa" },
            secondary: { main: "#c084fc" },
            error: { main: "#f87171" },
            warning: { main: "#fbbf24" },
            success: { main: "#34d399" },
            info: { main: "#60a5fa" },
            background: { default: "#0f0b1a", paper: "#1a1625" },
          }),
    },
    typography: {
      fontFamily: "'Inter', sans-serif",
    },
    shape: { borderRadius: 12 },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            borderRadius: 9999,
            fontWeight: 500,
          },
        },
        defaultProps: {
          disableElevation: true,
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 16,
            border: "1px solid",
            borderColor: mode === "light" ? "#e2e8f0" : "#2d2640",
          },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            "&.Mui-selected": {
              backgroundColor:
                mode === "light"
                  ? "rgba(124, 58, 237, 0.08)"
                  : "rgba(167, 139, 250, 0.12)",
              color: mode === "light" ? "#7c3aed" : "#a78bfa",
              "&:hover": {
                backgroundColor:
                  mode === "light"
                    ? "rgba(124, 58, 237, 0.12)"
                    : "rgba(167, 139, 250, 0.16)",
              },
            },
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            fontWeight: 500,
          },
        },
      },
    },
  });
}
